import { GlobalConfigType } from 'actions/global.config.type'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { applyTheme, resolveTheme } from 'utils/theme'

/**
 * Watches the signed-in user's `configuration.style` and the company default
 * (`globalSettings.ui.siteStyle`) and applies the resolved style to <html>.
 * Renders nothing. The initial (pre-render) apply happens in index.tsx from
 * localStorage; this keeps the document in sync as the profile or company
 * setting loads, and falls back to the company style on logout (profile cleared).
 */
export const ThemeApplier = () => {
  const userStyle = useSelector((state: any) => state.auth?.profile?.configuration?.style) as string | undefined
  const companyStyle = useSelector(
    (state: any) => state.globalConfigReducer[GlobalConfigType.GTM]?.ui?.siteStyle,
  ) as string | undefined

  useEffect(() => {
    applyTheme(resolveTheme(userStyle, companyStyle))
  }, [userStyle, companyStyle])

  return null
}
